module.exports = __webpack_public_path__ + "8042a88b88c0b4b40a7c8ce317c0ecb0.woff";